import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }


import editModal from './components/editModal.vue'
import { reactive, ref, computed, onMounted } from 'vue'
import { getuserCustomerAreaList, getDeptInfo } from '@/api/common'
import { BigScoreBakcData } from '@/typings/api/gucangSale'
const __default__ = { name: 'DcCosLbuEmployeeAreaSetting' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const editModalRef = ref<{ toggle:(row?: BigScoreBakcData) => void }>()

const tableRef = ref()
const deptInfoList = ref([])
const queryForm = reactive({
  employeeNo: '',
  userName: '',
  deptList: [],
  status: 1
})

// 获取列表
const fetch = async (params: object, callBack: (res: any) => void) => {
  const res = await getuserCustomerAreaList({ ...params, appId: 'cos_lbu' })
  callBack(res)
}
// 获取直接架构部门(与产品沟通过，不需要过滤)
const fetchDeptInfo = async () => {
  const res = await getDeptInfo({})
  deptInfoList.value = res.data?.deptInfo[0]?.children
}
const success = () => {
  tableRef.value.fetch()
}
onMounted(() => {
  fetchDeptInfo()
})

const statusEnum = [
  { value: 0, label: '离职' },
  { value: 1, label: '在职' }
]

const columns = computed(() => [
  { title: '员工名称', dataIndex: 'userName' },
  { title: '员工工号', dataIndex: 'employeeNo' },
  { title: '在职状态', dataIndex: 'status', dicData: statusEnum },
  { title: '上级名称 ', dataIndex: 'managerName' },
  { title: '部门 ', dataIndex: 'deptName' },
  { title: '客户区域 ', dataIndex: 'areaName' },
  { title: '操作人 ', dataIndex: 'operatorName' },
  { title: '操作时间 ', dataIndex: 'createTime' },

  {
    title: '操作',
    dataIndex: 'action',
    fixed: 'right'
  }
])
const addEdit = (_row?: BigScoreBakcData) => {
  editModalRef.value?.toggle(_row)
}
// const deleteRow = (row: BigScoreBakcData) => {
//   Modal.delete({
//     name: row.customerName,
//     onOk() {
//       deleteBiLoseWarning(row.id).then(() => {
//         DcMessage.success('删除成功')
//         success()
//       })
//     }
//   })
// }

return (_ctx: any,_cache: any) => {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_dc_form_item = _resolveComponent("dc-form-item")!
  const _component_CosCascader = _resolveComponent("CosCascader")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_more_button = _resolveComponent("more-button")!
  const _component_cos_table = _resolveComponent("cos-table")!
  const _component_dc_layout_content = _resolveComponent("dc-layout-content")!
  const _component_dc_layout_main = _resolveComponent("dc-layout-main")!
  const _directive_permission = _resolveDirective("permission")!

  return (_openBlock(), _createBlock(_component_dc_layout_main, null, {
    default: _withCtx(() => [
      _createVNode(_component_dc_layout_content, null, {
        default: _withCtx(() => [
          _createVNode(_component_cos_table, {
            serial: "",
            columns: columns.value,
            onFetch: fetch,
            search: queryForm,
            "onUpdate:search": _cache[5] || (_cache[5] = ($event: any) => ((queryForm) = $event)),
            ref_key: "tableRef",
            ref: tableRef,
            tableId: "DcCosEmployeeAreaSetting"
          }, {
            search: _withCtx(() => [
              _createVNode(_component_a_form, { model: queryForm }, {
                default: _withCtx(() => [
                  _createVNode(_component_dc_form_item, {
                    name: "employeeNo",
                    label: "员工工号"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.employeeNo,
                        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.employeeNo) = $event)),
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "userName",
                    label: "员工名称"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_input, {
                        value: queryForm.userName,
                        "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((queryForm.userName) = $event)),
                        allowClear: "",
                        placeholder: "请输入"
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "deptId",
                    label: "部门"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_CosCascader, {
                        fieldNames: { label: 'label', value: 'id' },
                        options: deptInfoList.value,
                        type: "search",
                        ids: queryForm.deptList,
                        "onUpdate:ids": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.deptList) = $event)),
                        "max-tag-count": "responsive",
                        changeOnSelect: true,
                        placeholder: "请选择部门"
                      }, null, 8, ["options", "ids"])
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_dc_form_item, {
                    name: "status",
                    label: "在职状态"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_select, {
                        value: queryForm.status,
                        "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((queryForm.status) = $event)),
                        allowClear: "",
                        placeholder: "请选择",
                        options: statusEnum
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["model"])
            ]),
            button: _withCtx(() => [
              _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                type: "primary",
                onClick: _cache[4] || (_cache[4] = ($event: any) => (addEdit()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("新增")
                ]),
                _: 1
              })), [
                [_directive_permission, 'lbu_employareaset_add_btn']
              ])
            ]),
            bodyCell: _withCtx(({ column, record }) => [
              (column.dataIndex === 'riskLevel')
                ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(['低', '中', '高'][record.riskLevel - 1] || '--'), 1))
                : _createCommentVNode("", true),
              (column.dataIndex === 'action')
                ? (_openBlock(), _createBlock(_component_more_button, { key: 1 }, {
                    default: _withCtx(() => [
                      _withDirectives((_openBlock(), _createBlock(_component_a_button, {
                        type: "link",
                        onClick: ($event: any) => (addEdit(record))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("分配区域")
                        ]),
                        _: 2
                      }, 1032, ["onClick"])), [
                        [_directive_permission, 'lbu_employareaset_edit_btn']
                      ])
                    ]),
                    _: 2
                  }, 1024))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["columns", "search"]),
          _createVNode(editModal, {
            ref_key: "editModalRef",
            ref: editModalRef,
            onSuccess: success
          }, null, 512)
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})